import React, { useEffect, Suspense } from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { persistStore } from 'redux-persist'

import App from './App'
import { resize } from '../actions/app'
import { history, configureStore } from '../store/configureStore'

import Loading from './Loading'

const store = configureStore()
const persistor = persistStore(store)

const Root = () => {
    const dispatchResize = () => {
        const { innerHeight: height, innerWidth: width } = window
        store.dispatch(resize(width, height))
    }

    useEffect(() => {
        window.addEventListener('resize', dispatchResize)
    }, [])

    return (
        <Provider store={store} history={history} persistor={persistor}>
            <Suspense>
                <PersistGate loading={<Loading />} persistor={persistor}>
                    <ConnectedRouter history={history}>
                        <App />
                    </ConnectedRouter>
                </PersistGate>
            </Suspense>
        </Provider>
    )
}

export { store }

export default Root
